import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { FileManagerState } from '../reducers/file-manager.reducer';
import { FileManagerLocation } from '../../models/file-manager.model';

export const getFileManagerState = createFeatureSelector<FileManagerState>(
  'fileManager'
);

export const getCurrentLocation = createSelector(
  getFileManagerState,
  (state: FileManagerState) => state.currentLocation
);
export const getFileStoreSelectedItems = createSelector(
  getFileManagerState,
  (state: FileManagerState) => state.selectedItems
);
export const getFileStoreSelectedGridItems = createSelector(
  getFileManagerState,
  (state: FileManagerState) => state.selectedGridItems
);
